document.addEventListener('DOMContentLoaded', () => {
  tabsTypeB();
});

const TABS_ACCORDION_HEADER_GAP = 24;

/**
 * Returns the current sticky header height (plus the WP admin bar on
 * desktop) and a fixed gap, so scrolled content isn't hidden behind them.
 */
function getTabsAccordionHeaderOffset() {
  const header = document.querySelector('.js-header');
  const headerHeight = header ? header.getBoundingClientRect().height : 0;
  const isMobile = window.innerWidth <= 600;
  const wpadminbar = isMobile ? 0 : document.getElementById('wpadminbar')?.clientHeight ?? 0;

  return headerHeight + wpadminbar + TABS_ACCORDION_HEADER_GAP;
}

/* Tabs Type A */
const tabsTypeB = () => {
  const tabSections = document.querySelectorAll('.js-tabs-accordions');

  tabSections.forEach(section => {
    const navItems = section.querySelectorAll('.js-tab-accordion');
    const tabs = section.querySelectorAll('.js-tab-media');

    // Nav item click logic
    navItems.forEach((nav, index) => {
      nav.addEventListener('click', () => {
        setActiveTab(index);

        // Wait a paint frame so the toggled layout is committed before measuring
        requestAnimationFrame(() => scrollAccordionNavIntoView(nav));
      });
    });

    function setActiveTab(index) {
      navItems.forEach(item => item.classList.remove('active'));
      tabs.forEach(tab => tab.classList.remove('active'));

      if (navItems[index]) navItems[index].classList.add('active');
      if (tabs[index]) tabs[index].classList.add('active');
    }
  });
};

/**
 * Scrolls the active accordion's title into view if it's hidden behind the
 * sticky header or below the viewport, leaving it untouched if already visible.
 *
 * Only the nav title is checked (not its paired sticky media panel): a
 * `position: sticky` element's rect always reads as "on screen" once engaged,
 * which would otherwise mask the nav title actually being off-screen.
 */
function scrollAccordionNavIntoView(nav) {
  const headerOffset = getTabsAccordionHeaderOffset();
  const rect = nav.getBoundingClientRect();
  const isAboveViewport = rect.top < headerOffset;
  const isBelowViewport = rect.bottom > window.innerHeight;

  if (!isAboveViewport && !isBelowViewport) return;

  const top = rect.top + window.scrollY - headerOffset;
  window.scrollTo({ top, behavior: 'smooth' });
}
